export default {
    types: {
        "ac_router": "AC router",
        "chair": "Židle",
        "desk": "Stůl",
        "desktop": "Počítač",
        "desktop_riser": "Podstavec pro stolní počítač",
        "detector": "Detektor vaporizérů a hluku",
        "displayport_cable": "Kabel DisplayPortu",
        "docking station": "Dokovací stanice",
        "dual_usb_adapter": "Dvoupásmový USB adaptér",
        "ear cushion": "Náušní polštářek",
        "footrest": "Opěrka nohou",
        "hdmi_cable": "HDMI kabel",
        "hdmi_displayport_cable": "Kabel HDMI na DisplayPort",
        "hdmi_vga_cable": "Kabel HDMI-VGA",
        "headset": "Sluchátka",
        "keyboard": "Klávesnice",
        "kvm switch": "KVM přepínač",
        "kvm_switch": "KVM přepínač",
        "lamp": "Svítilna",
        "laptop stand": "Stojan na notebook",
        "laptop": "Notebook",
        "mesh_router": "Síťový router",
        "monitor": "Monitor",
        "mouse": "Myš",
        "patch_cord": "Patch kabel Cat6",
        "power": "Napájecí kabel",
        "power_center": "Energetické centrum",
        "power_strip": "Prodlužovací kabel",
        "printer": "Tiskárna",
        "smart_plug": "Chytrá zásuvka mini",
        "smart_power_strip": "Chytrý prodlužovací kabel",
        "speakerphone": "Hlasitý telefon",
        "stylus": "Stylus",
        "tablet": "Tableta",
        "tablet accessory": "Příslušenství k tabletu",
        "thunderbolt_cable": "USB-C na Thunderbolt",
        "travel_router": "Cestovní router",
        "usb hub": "USB rozbočovač",
        "usb_adapter": "USB adaptér",
        "usb_hub": "USB rozbočovač",
        "webcam": "Webkamera"
    }
}